import { useState } from 'react';
import SectionHeader from '@/components/base/SectionHeader';

const faqs = [
  {
    q: '什么是治愈番？',
    a: '治愈番泛指能让人心情放松、感到温暖和治愈的动画，题材多为温馨日常、细腻情感或温柔奇幻，看完会让人重新觉得世界很美好。',
  },
  {
    q: '牛奶动漫库的补番目录怎么用？',
    a: '你可以通过首页的搜索框按动画名或标签查找，也可以直接进入治愈番专区或日常番合集，按心情和标签快速挑选想看的作品。',
  },
  {
    q: '日常番和搞笑番有什么区别？',
    a: '日常番更侧重描绘平凡生活的细腻与悠然，节奏舒缓；搞笑番则以密集笑点和无厘头为主。很多作品会两者兼具，比如《日常》和《男子高中生的日常》。',
  },
  {
    q: '有哪些适合入坑的萌系动画？',
    a: '如果喜欢软萌短篇，推荐《罗小黑战记》《轻松熊和小薰》《请吃红小豆吧！》，可爱又轻松，非常适合碎片时间观看。',
  },
  {
    q: '看治愈番需要按顺序补吗？',
    a: '大多治愈番是单元剧或独立故事，可以随心情挑选观看。涉及连续剧情的作品，建议按年份顺序补，观感会更好。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeader
        eyebrow="常见问题"
        title="关于补番，你可能想问"
        description="整理了大家常问的问题，帮助你更快上手牛奶动漫库。"
      />
      <div className="mx-auto max-w-3xl divide-y divide-background-200 rounded-2xl bg-background-100/70 px-2">
        {faqs.map((item, index) => {
          const open = openIndex === index;
          return (
            <div key={item.q}>
              <button
                type="button"
                onClick={() => setOpenIndex(open ? -1 : index)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-4 px-4 py-5 text-left"
              >
                <h3 className="text-base font-semibold text-foreground-950">{item.q}</h3>
                <i
                  className={`shrink-0 text-xl text-primary-600 transition-transform ${
                    open ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`grid transition-all duration-300 ${
                  open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-4 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}